var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"rules":_vm.rules,"name":_vm.errorLabelText},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var valid = ref.valid;
return [_c('b-field',{attrs:{"label":_vm.label,"type":{'is-danger': errors.length },"message":errors[0],"custom-class":"test-color"}},[_c('b-input',{attrs:{"size":"is-small","name":_vm.name,"type":_vm.type},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }